import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { getTestProps } from '../../lib/helpers';

import useDarkMode from '../../hooks/useDarkMode';

import { BrandheroSadDark, BrandheroSadLight } from '../../images/shapes';

const PluginsExceededModalContent = ({ limit = 0, count = 0, testId = '' }) => {
  const { t } = useTranslation();
  const [darkMode] = useDarkMode();

  const BrandheroComponent = darkMode ? BrandheroSadDark : BrandheroSadLight;

  return (
    <div className="flex flex-col items-center justify-center">
      <BrandheroComponent className="w-32" />
      <h2 className="text-3xl my-1">{t('Limits.PluginsExceeded.Title')}</h2>
      <p
        className="text-lg text-center"
        {...getTestProps(testId, 'description')}
      >
        <Trans
          i18nKey="Limits.PluginsExceeded.Description"
          components={{
            1: <strong />,
            2: <br />,
          }}
          values={{
            limit,
            count,
            pluginsLimitTranslation: t('Limits.PluginsExceeded.Plugins', {
              count: limit,
            }),
            pluginsCountTranslation: t('Limits.PluginsExceeded.Plugins', {
              count,
            }),
          }}
        />
      </p>
    </div>
  );
};

export default PluginsExceededModalContent;

PluginsExceededModalContent.propTypes = {
  /**
   * Plugins limit
   */
  limit: PropTypes.number,
  /**
   * Plugins count
   */
  count: PropTypes.number,
  /**
   * Component test id
   */
  testId: PropTypes.string,
};
